import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { StorageRoutePage } from "../app/storageRoute";

export const Route = createFileRoute("/storage")({
  component: StorageRoute,
});

function StorageRoute(): JSX.Element {
  const search = Route.useSearch();
  return <StorageRoutePage search={search} />;
}
